<div class="upload-item">
    <div class="text" *ngIf="!task.task && !embedded">
        <div class="title my-color-blue" [innerHTML]="task.title | safeHtml"></div>
    </div>
    <app-journey-list-template-checkbox
            *ngIf="task.task" class="blue"
            [task]="task"></app-journey-list-template-checkbox>

    <div *ngIf="!!task.text" class="text"><strong>{{task.text}}</strong></div>
    <div class="upload-container">
        <div class="label" *ngIf="isLoadedFile" (click)="fileOpen()">{{task.details.file.title}}</div>
        <label *ngIf="!isLoadedFile" #fileLabel for="file_uploads">{{'__JOURNEY_FILE_SELECT_FILE__' | translate}}</label>
        <input *ngIf="!isLoadedFile" (change)="fileChange($event)" #file type="file" id="file_uploads"/>
        <div class="upload-button-container">
            <div>
                <button (click)="upload()" [ngClass]="{active: !isLoadedFile && isFileSelected}" class="upload"></button>
                {{'__JOURNEY_FILE_UPLOAD_FILE__' | translate}}
            </div>
            <div>
                <button (click)="openConfirmDialog()" [ngClass]="{active: isLoadedFile}" class="delete"></button>
                {{'__JOURNEY_FILE_DELETE_FILE__' | translate}}
            </div>
        </div>
    </div>
    <div *ngIf="isConfirmOpened" class="confirm-dialog">
        <div class="confirm-title">{{'__JOURNEY_FILE_DELETE_CONFIRM_MESSAGE__' | translate}}</div>
        <div class="confirm-button-container">
            <button (click)="delete(true)">{{'__JOURNEY_FILE_DELETE_CONFIRM_YES__' | translate}}</button>
            <button (click)="delete(false)"> {{'__JOURNEY_FILE_DELETE_CONFIRM_NO__' | translate}}</button>
        </div>
    </div>
    <div *ngIf="isShowProgress && !!progressValue" class="progress" [style.background]="progressValue">{{progressTitle | translate}}</div>
</div>
